const prefix = '/ova/api';
const prefix_traslados = '/traslados/api';
const prefix_cotizador = "/cotizador/api";
export const URL_MAP = {
  prefix,
  TOKEN: 'YgnlyGqCqXmO5bizOkKk831D8bg3M4It',
  TOKEN_SARLAFT: '0e1dbb06-0214-45da-99d5-d069f26d0679',
  ID_APP: 89,
  API: {
    baseURL: '/api',
    termURL: '/saludmp-ws/jax-rs/saludmp-infousuariovd/APPMP/APPMP3320/TC/COT',
    //serviceURLMyQuoter: "/cotizador/api/cotizador",
    serviceURLMyQuoter: '/cotizador',
    serviceProduct: '/Admin-contenido/Backend/api',
    GETSECURETOKEN:
      '/token?username=${userNameSecure}&password=${passwordSecure}',
    VALIDALOGUEO: '/auth/login',
    GENERICEXECUTE: '/msc-back/generic-service/execute',

    LISTPORTAFOLIO: `${prefix}/resource/list`,
    SAVEFAVORITEPORTAFOLIO: `${prefix}/favorite/save`,
    DOWNLOADCOUNT: `${prefix}/resource/logdownload`,
    GETCARNETAFILIADOS: `${prefix}/card/affiliates`,
    GETCARNET: `${prefix}/card/carnet`,
    GETPOBLACIONVALORES: `${prefix}/population/getlistvalues`,
    GETPOBLACIONEDADCARTERA: `${prefix}/population/portfolioage`,
    GETPOBLACIONUSUARIOSACTIVOS: `${prefix}/population/activeusers`,
    GETPOBLACIONUSUARIOSRETIRADOS: `${prefix}/population/retiredusers`,
    GETPOBLACIONMISUSUARIOS: `${prefix}/population/myusers`,
    GETPOBLACIONDETALLEUSUARIO: `${prefix}/population/usersdetail`,
    GETPOBLACIONDETALLEANEXOUSUARIO: `${prefix}/population/userdetailannexes`,
    GETVERSIONTYC_HD: `${prefix}/tyc/getversiontyc`,
    GETDATATYC_HD: `${prefix}/tyc/getdocumenttyc`,
    ACCEPTTYC_HD: `${prefix}/tyc/aceptdoctyc`,
    CODIGOASESOR: `${prefix}/asesor/consultarCodigodelAsesor`,
    COMISIONES: `${prefix}/datos/comisiones`,
    AFILIACIONES_AFE: `${prefix}/afiliado/consultarSolicitudesDeAfiliacion`,
    AFILIACIONES_SHAREPOINT: `${prefix}/afiliado/consultarSolicitudesDeAfiliacionSharePoint`,
    OPORTUNIDADES_COMERCIALES_INTERNOS: `${prefix}/oportunidades`,
    OPORTUNIDADES_COMERCIALES_INTERNOS_SEMAFORIZACION: `${prefix}/oportunidades/consultarReglasDeSemaforizacion`,
    OPORTUNIDADES_COMERCIALES_INTERNOS_MODAL: `${prefix}/oportunidades/mostrarMensajeModal`,
    OPORTUNIDADES_COMERCIALES_EXTERNOS_SEMAFORIZACION: `${prefix}/oportunidadesExternos/colorSemaforoExterno`,
    OPORTUNIDADES_COMERCIALES_EXTERNOS_MODAL: `${prefix}/oportunidadesExternos/mostrarMensajeModal`,
    OPORTUNIDADES_COMERCIALES_EXTERNOS: `${prefix}/oportunidadesExternos`,
    TRACKING: `${prefix}/tracking/registrar`,
    LOGIN: `${prefix}/auth/login`,
    GESTION_REFERIDOS: `${prefix}/gestion-referido`,
    NOTIFICACION_DETALLE: `${prefix}/notificacion-detalle`,
    NOTIFICACION_REFERIDO: `${prefix}/notificacion-referido`,
    AUTORIZACIONES: `${prefix}/autorizaciones`,
    REFERIDOS: `${prefix}/referidos/consultarReferidos`,
    BENEFICIARIOS_REFERIDOS: `${prefix}/referidos/consultarBeneficiarios`,
    CERTIFICADOS_RETENCIONES: `${prefix}/certificados`,
    DOWNLOAD_TOKEN: `${prefix}/descargas/token`,
    SENDMESSAGE_WOLKVOX: `${prefix}/descargas/enviar`,
    DOWNLOAD_REPORTE: `${prefix}/descargas/descargar`,
    CERTIFICADOS: `${prefix}/reports`,
    MOMENTOS_WOW: `${prefix}/momentoswow`,

    // --- Solo en doc 5 (traslados y nuevos) ---
    ESTADOS_CIVILES: `${prefix_traslados}/estados-civiles`,
    CORTES: `${prefix_traslados}/cortes`,
    CUESTIONARIO_SALUD: `${prefix_traslados}/cuestionarios-salud`,
    TIPOS_DOCUMENTO: `${prefix_traslados}/tipos-documento`,
    TIPOS_PLAN: `${prefix_traslados}/tipos-plan`,
    TIPOS_PLAN_RADICACION_TRASLADOS: `${prefix_traslados}/tipos-plan-radicacion-traslados`,
    ESTRATOS_SOCIALES: `${prefix_traslados}/estratos-sociales`,
    LINEAS_NEGOCIO: `${prefix_traslados}/lineas-negocio`,
    OCUPACIONES: `${prefix_traslados}/ocupaciones`,
    NACIONALIDADES: `${prefix_traslados}/nacionalidades`,
    PROFESIONES: `${prefix_traslados}/profesiones`,
    GENEROS: `${prefix_traslados}/generos`,
    SUBCUENTAS_PROGRAMA: `${prefix_traslados}/subcuentas-programa`,
    INFOMEDICAL_SUBCUENTA_PROGRAMA: `${prefix_traslados}/infomedical-subcuenta-programa`,
    OTP_GENERAR: `${prefix_traslados}/otp/generar`,
    OTP_VALIDAR: `${prefix_traslados}/otp/validar`,
    FIRMA_SESION: `${prefix_traslados}/firma/sesion`,
    FIRMA_SOLICITUD: `${prefix_traslados}/firma/solicitud`,
    FIRMA_EJECUTAR: `${prefix_traslados}/firma/ejecutar`,
    FIRMA_ENLACE: `${prefix_traslados}/firma/enlace`,
    FIRMA_ELECTRONICA_EJECUTAR: `${prefix_traslados}/firma-electronica/ejecutar`,
    RECAPTCHA_SITE_KEY: '6Lc0M7EsAAAAANL8rN2ErAbjBMOpFsJgMg9SOqG6',
    CONTRATOS_USER: `${prefix_traslados}/contratos-users`,
    CONTRATOS_USER_DATOS_FORMULARIO_CONTRATANTE: `${prefix_traslados}/contratos-users/datos-formulario-contratante`,
    DATOS_AFILIADO_PAGADOR: `${prefix_traslados}/datos-afiliado-pagador`,
    INFORMACION_CONTRATO_USER: `${prefix_traslados}/info-contrato-user`,
    GRUPOS_PROGRAMAS_ACTIVOS: `${prefix_traslados}/grupos-programas-activos`,
    PROGRAMAS_LINEA_NEGOCIO: `${prefix_traslados}/programas-linea-negocio`,
    TIPOS_PRIMA: `${prefix_traslados}/tipos-prima`,
    TARIFAS_DESTINO: `${prefix_traslados}/cambio-tarifa/tarifas`,
    CAMBIO_TARIFA_TARIFAS: `${prefix_traslados}/cambio-tarifa/tarifas`,
    CAMBIO_TARIFA_COTIZADOR_TRL: `${prefix_traslados}/tarifas-cotizador-trl`,
    VALIDACION_CONTRATO: `${prefix_traslados}/validacion-contrato`,
    VALIDACION_CONTRATO_USER: `${prefix_traslados}/validacion-contrato-user`,
    SOLICITUDES_RADICADAS: `${prefix_traslados}/solicitudes-radicadas`,
    VALIDACION_SOLICITUD_ACTIVA: `${prefix_traslados}/validacion-solicitud-activa`,
    PERFILAMIENTO_VALIDAR: `${prefix_traslados}/perfilamiento/validar`,
    TIPOS_SOLICITUD: `${prefix_traslados}/tipos-solicitud`,
    TIPOS_NOVEDAD: `${prefix_traslados}/tipos-novedad`,
    REGLAS_PERFILAMIENTO_TIPO_NOVEDAD: `${prefix_traslados}/reglas-perfilamiento-tipo-novedad`,
    SUBTIPOS_NOVEDAD: `${prefix_traslados}/subtipos-novedad`,
    BENEFICIARIOS_TARIFA_CONTRATO: `${prefix_traslados}/beneficiarios-tarifa`,
    ANEXOS_DESTINO: `${prefix_traslados}/anexos-destino`,
    ADICIONA_ANEXO_CONSULTA: `${prefix_traslados}/adiciona-anexo/consulta`,
    TIPO_PRIMA_PROGRAMA_NEGOCIO: `${prefix_traslados}/tipo-prima-programa-negocio`,
    CUENTA_COLECTIVO_CORPORATIVO: `${prefix_traslados}/cuenta-colectivo-corporativo`,
    COLECTIVO_ESPECIAL: `${prefix_traslados}/colectivo-especial`,
    conultarDatosUsuario: `${prefix_traslados}/usuario/detalle`,
    CONSULTA_COINCIDENCIA: `${prefix_traslados}/consulta-coincidencia`,
    PARTIDOS_COMERCIALES: `${prefix_traslados}/partidos-comerciales`,
    PARENTESCOS_TRASLADOS: `${prefix_traslados}/parentescos`,
    TRASLADOS: `${prefix_traslados}`,
    VALIDACION_PERFILAMIENTO: `${prefix_traslados}/validaciones-perfilamiento`,
    PERFILAMIENTO_EVALUAR: `${prefix_traslados}/perfilamiento/evaluar`,
    INTERFAZ_PERFILAMIENTO: `${prefix_traslados}/interfaz-auditoria/validar`,
    SOPORTES: `${prefix_traslados}/soportes`,
    CUESTIONARIO_SNAPSHOT: `${prefix_traslados}/cuestionario-snapshot`,
    RADICAR_SOLICITUD: `${prefix_traslados}/solicitudes/radicar`,
    VALIDAR_SOLICITUD_DUPLICADA: `${prefix_traslados}/solicitudes/validar-duplicado`,
    SOLICITUDES_DOCUMENTOS_PERSISTIR_RUTA: `${prefix_traslados}/solicitudes/documentos-generados/persistir-ruta`,
    DOCUMENTOS_PARAMETRIZADOS: `${prefix_traslados}/documentos-parametrizados`,
    REPORTS_GENERAR_DOCUMENTOS_SOLICITUD: `${prefix_traslados}/reports/generar-documentos-solicitud`,
    REPORTS_GENERAR_DOCUMENTO_BASE: `${prefix_traslados}/reports`,
    DOCUMENTOS_GENERADOS: `${prefix_traslados}/documentos-generados`,
    DOCUMENTOS_GENERADOS_VALIDAR_FIRMA: `${prefix_traslados}/documentos-generados/validar-firma`,
    DOCUMENTOS_GENERADOS_LOTE: `${prefix_traslados}/documentos-generados/lote`,
    INTEGRANTES_SOLICITUD: `${prefix_traslados}/integrantes-solicitud`,
    INTEGRANTES_SOLICITUD_LOTE: `${prefix_traslados}/integrantes-solicitud/lote`,
    FILE_UPLOAD: `${prefix_traslados}/files/upload`,
    FILE_DELETE: `${prefix_traslados}/files/delete`,
    FILE_DOWNLOAD: `${prefix_traslados}/files/download`,
    PROVINCIAS_X_PAIS: `${prefix_traslados}/provincias-por-pais`,
    MUNICIPIOS_POR_DEPARTAMENTO: `${prefix_traslados}/municipios-por-departamento`,
    PARENTESCO_SERVICIO: `${prefix_cotizador}/afe/parentesco`,
    CONSULTAR_ADRES_SERVICIO: `${prefix_cotizador}/afe/adres`,
    CONSULTAR_TIPOS_VIA_SERVICIO: `${prefix_cotizador}/afe/tipoVia`,
    GUARDAR_DATOS_BENEFICIARIOS: `${prefix_cotizador}/afe/beneficiario/datosBeneficiario`,
    ACTUALIZAR_DATOS_BENEFICIARIOS: `${prefix_cotizador}/afe/beneficiario/datosBeneficiario`,
    ELIMINAR_DATOS_BENEFICIARIOS: `${prefix_cotizador}/afe/beneficiario/deleteDatosBeneficiario`,
    GUARDAR_BENEFICIARIO_PROGRAMAS: `${prefix_cotizador}/afe/beneficiario/guardarBeneficiarioProgramas`,
    ACTUALIZAR_BENEFICIARIO_PROGRAMAS: `${prefix_cotizador}/afe/beneficiario/actualizarBeneficiarioProgramas`,
    ELIMINAR_BENEFICIARIO_PROGRAMAS: `${prefix_cotizador}/afe/beneficiario/deleteBeneficiarioPrograma`,
    GUARDAR_SUBCUENTAS: `${prefix_cotizador}/afe/beneficiario/guardarSubcuentas`,
    ACTUALIZAR_SUBCUENTAS: `${prefix_cotizador}/afe/beneficiario/actualizarSubcuentas`,
    ELIMINAR_SUBCUENTAS: `${prefix_cotizador}/afe/beneficiario/deleteSubcuenta`,
    GUARDAR_TARIFAS: `${prefix_cotizador}/afe/beneficiario/guardarTarifas`,
    ACTUALIZAR_TARIFAS: `${prefix_cotizador}/afe/beneficiario/actualizarTarifas`,
    ELIMINAR_TARIFAS: `${prefix_cotizador}/afe/beneficiario/deleteTarifa`,
    GUARDAR_CAMPANIAS: `${prefix_cotizador}/afe/beneficiario/guardarCampanias`,
    ACTUALIZAR_CAMPANIAS: `${prefix_cotizador}/afe/beneficiario/actualizarCampanias`,
    ELIMINAR_CAMPANIAS: `${prefix_cotizador}/afe/beneficiario/deleteCampania`,
    CONSULTAR_BENEFICIARIO_PROGRAMA: `${prefix_cotizador}/afe/beneficiario/consultarBeneficiarioPrograma`,

    ANEXOS_COLECTIVOS_GRUPOS: `${prefix_cotizador}/consultarAnexos`,
    CONSULTAR_ASESOR_BY_ID: `${prefix_cotizador}/afe/consultarAsesorXID`,
    CONSULTAR_ASOCIADO: `${prefix_cotizador}/consultarAsociado`,
    CONSULTAR_CAMPANAS_NUEVAS: `${prefix_cotizador}/consultarCampanias`,
    CONSULTAR_CIUDADES: `${prefix_cotizador}/consultarCiudades`,
    CONSULTAR_DATOS_USUARIO: `${prefix_cotizador}/consultarDatosUsuario`,
    CONSULTAR_COTIZACION_CONTRATANTE: `${prefix_cotizador}/consultarCotizacionContratante`,
    PROGRAMAS_CONTRATANTE: `${prefix_cotizador}/programas-contratante`,
    CONSULTAR_LINEAS_NEGOCIO: `${prefix_cotizador}/consultarLineasNegocio`,
    CONSULTAR_GRUPOS_PROGRAMAS_ACTIVOS: `${prefix_cotizador}/consultarGruposProgramasActivos`,
    CONSULTAR_PROGRAMAS_ACTIVOS: `${prefix_cotizador}/consultarProgramasActivos`,
    CONSULTAR_CARNETS: `${prefix_cotizador}/consultarCarnets`,
    CONSULTAR_PROGRAMAS_BY_PARAMETRO: `${prefix_cotizador}/consultarProgramasByParametro`,
    CONSULTAR_PROGRAMAS_INCLUSION: `${prefix_cotizador}/consultarProgramasInclusion`,
    CONSULTAR_TARIFAS_INDIVIDUALES: `${prefix_cotizador}/consultarTarifasIndividuales`,
    CONSULTAR_TARIFAS_INDIVIDUALES_VALORES: `${prefix_cotizador}/consultarTarifasIndividuales/valores`,
    CONSULTAR_HISTORIAL: `${prefix_cotizador}/consultarHistorial`,
    CONSULTAR_SUBCUENTAS: `${prefix_cotizador}/consultarSubcuentas`,
    VALIDAR_COBERTURA: `${prefix_cotizador}/afe/contrato/validar-cobertura`,
    COT_CONSULTAR_TARIFA: `${prefix_cotizador}/afilmed/cotConsultarTarifa`,
    CONSULTA_ACTIVO_AC: `${prefix_cotizador}/afilmed/consultaActivoAc`,
    DOCUMENTOS_TIPOS_DOCUMENTOS: `${prefix_cotizador}/docuTipos/documentos`,
    USUARIO_ACTIVO_CONTRATOS: `${prefix_cotizador}/usuario-activo/contratos`,
    COTIZACION: `${prefix_cotizador}/cotizacion`,
    COTIZACION_DESDE_PASO_CONTRATANTE: `${prefix_cotizador}/cotizacion/desde-paso-contratante`,
    CONSULTAR_CAMPANIA_DETALLE: `${prefix_cotizador}/cotizador/consultarCampaniaDetalle`,
    CONSULTAR_DESCUENTOS_PRONTO_PAGO: `${prefix_cotizador}/consultarDescuentosProntoPago`,
    CONSULTAR_GRUPO_PROGRAMA_X_PROGRAMA: `${prefix_cotizador}/consultarGrupoProgramaXPrograma`,
    CONSULTAR_CUOTA_INSCRIPCION: `${prefix_cotizador}/cotizador/consultarCuotaInscripcion`,
    GUARDAR_COTIZACION_LIQUIDACION: `${prefix_cotizador}/cotizador/guardarCotizacionLiquidacion`,
    ACTUALIZAR_COTIZACION_LIQUIDACION: `${prefix_cotizador}/cotizador/actualizarCotizacionLiquidacion`,
    GUARDAR_COTIZACION_COMPARATIVO: `${prefix_cotizador}/cotizador/guardarCotizacionComparativo`,
    ACTUALIZAR_COTIZACION_COMPARATIVO: `${prefix_cotizador}/cotizador/actualizarCotizacionComparativo`,
    CONSULTAR_COTIZACION_COMPARATIVO: `${prefix_cotizador}/cotizador/consultarCotizacionComparativo`,
    COTIZACION_CONTRATANTE_ACTUALIZAR_VALIDACIONES: `${prefix_cotizador}/cotizacion-contratante/actualizar-validaciones`,
    NOTIFICACIONES_COTIZACION: `${prefix_cotizador}/notificaciones`,
    COTIZADOR_COTIZACION: `${prefix_cotizador}/cotizacion`,
    COTIZADOR_COTIZACION_PAGINADO: `${prefix_cotizador}/cotizacion/paginado`,
    COTIZADOR_CODIGO_ASESOR: `${prefix_cotizador}/cotizacion/asesor/codigo_asesor`,
    COTIZADOR_TIPO_SOLICITUD: `${prefix_cotizador}/tipo-solicitud`,
    COTIZADOR_MOTIVOS_CIERRE: `${prefix_cotizador}/motivosCierre`,
    COTIZADOR_VENTA_GANADA: `${prefix_cotizador}`,
    COTIZADOR_PROBABILIDAD_CIERRE: `${prefix_cotizador}/cotizacion-probabilidad-cierre`,
    COTIZADOR_CANALES_ATENCION: `${prefix_cotizador}/afilmed/canalesDeAtencion`,
    COTIZADOR_COTIZACION_ESTADO: `${prefix_cotizador}/cotizacion-estado`,
    COTIZADOR_COTIZACION_EXPORTAR: `${prefix_cotizador}/cotizacion/exportar`,
    TIPOS_DE_DOCUMENTOS: `${prefix_cotizador}/docuTipos`,
    CONTRATOS: `${prefix_cotizador}/usuario-activo/contratos`,
    DATOS_X_EMPRESA: `${prefix_cotizador}/afilmed/DatosXEmpresa`,
    AFE: `${prefix_cotizador}/afe`,
    AFILMED: `${prefix_cotizador}/afilmed`,
    CONSULTARANEXOS: `${prefix_cotizador}/consultarAnexos`,
    OBTENER_LIQUIDACION_COLECTIVO: `${prefix_cotizador}/afe/liquidacion-colectivo`,
    COTIZACIONCOLECTIVO: `${prefix_cotizador}/cotizacion-colectivo`,
    GUARDAR_LIQUIDACION_COLECTIVO: `${prefix_cotizador}/afe/liquidacion-colectivo/guardar`,
    SINCRONIZAR_LIQUIDACION_COLECTIVO: `${prefix_cotizador}/afe/liquidacion-colectivo/cotizacion`,
    COTIZACIONCOLECTIVOCONTACTO: `${prefix_cotizador}/cotizacion-colectivo-contacto`,
    CREARCOTIZACION: `${prefix_cotizador}`,
    COTIZADOR_TARIFA_COLECTIVO: `${prefix_cotizador}/tarifa-colectivo`,
    SEGUIMIENTO_JEFE_ASESORES: `${prefix_cotizador}/afe/seguimiento-jefe/asesores`,
    SEGUIMIENTO_JEFE_REGISTROS: `${prefix_cotizador}/afe/seguimiento-jefe/registros`,
    SEGUIMIENTO_JEFE_EXPORTAR: `${prefix_cotizador}/afe/seguimiento-jefe/exportar`,
    PDF_COTIZACION_COLECTIVO: `${prefix_cotizador}/certificados/pdf/cotizacolectivo`,
    PDF_COTIZACION_INDIVIDUAL: `${prefix_cotizador}/certificados/pdf/cotizaindi`,
    EMAIL_COTIZACION: `${prefix_cotizador}/email/enviar`,
    ACTUALIZAR_BENEFICIARIO_PROGRAMA: `${prefix_cotizador}/afe/beneficiario/beneficiarioPrograma`,
    CONSULTAR_PROGRAMAS_LINEA_NEGOCIO: `${prefix_cotizador}/carnet-programa/consultar-programa-by-lineaNegocio`,
    CONSULTAR_PROGRAMAS_CARNETS: `${prefix_cotizador}/carnet-programa/consultarCarnets`,
    CONSULTAR_PROGRAMA_HOMOLOGO_ASOCIADO: `${prefix_cotizador}/carnet-programa/consultar-programa-homologo-asociado`,
    CONSULTAR_COTIZACION_ACTIVA: `${prefix_cotizador}/activa`,
    TRAZABILIDAD: `${prefix_cotizador}/registrar`,
    PARAMETROS_TRAZABILIDAD: `${prefix_cotizador}/trazabilidad/parametros`,
  },
  KEYS: {
    DIRECTORIO: "/dist/#/directory",
    LINKPAGO: "/link-de-pagos-coomeva/cuotamensual/obtener-datos",
    FACTURA: "/dist/#/payment/credentials",
    RECUPERAR_PASSWORD: "/profilemp-web/restclave.jspx",
    AUTHINFO: "auth_091f56561bb923234922726b582bab56",
    KEY: "auth_43223334f2f287938e370861e9333a78"
  },
  EXTERNAL: {
    DIRECTORIO: '/dist/#/directory',
    FACTURA: '/dist/#/payment/credentials',
    LINKPAGO: '/link-de-pagos-coomeva/cuotamensual/obtener-datos',
    // Doc 5 tiene las URLs correctas con /ova/api/, doc 4 usaba rutas relativas sin prefijo
    serviceSolicitud: '/ova/api/solicitudes/radicar',
    serviceAfiliado: '/ova/api/afiliado',
    serviceCorreo: '/ova/api/correo/enviarEmail',
    downloadFiles: '/msc-back/fileServer/download',
    fileUrl: '/ova/api/solicitudes/file',
    VISOR_MEDICO: "/public/visor-medico",
    autologinUserLinkPago: '999999999',
    autologinPassLinkPago: 'C00m3v4S3cur3',
    LINKPAGO_PRIMERA_CUOTA: '/link-de-pagos-coomeva/primeracuota/obtener-datos',
    LINKPAGO_GESTOR: '/link-de-pagos-coomeva/gestorlinks/obtener-datos',

    // Solo en doc 4
    GET_CREDENCIAL: '/ova/api/afiliadosCore',
  },
  RETENTION: {
    URL: 'https://oficinavirtualmp.coomeva.com.co/msc-back/reports/retefuente?format=pdf&reportName=retefuente',
    YEAR: {
      URL: 'https://oficinavirtualmp.coomeva.com.co/saludmp-ws/jax-rs/saludmp-aniosrtefuente/',
      SYSTEM: 'MPAPP',
      TOKEN: 'YgnlyGqCqXmO5bizOkKk831D8bg3M4It'
    }
  },
  version: '1.1.1',
  userNameSecure: "8050097415",
  passwordSecure: "yrJPCgtKsf78jwGxCxHrw",
  autologinApplication: "ODA1MDA5NzQxNQ==",
  autologinPassword: "eXJKUENndEtzZjc4andHeEN4SHJ3",
}